import { createContext } from 'react';

const dataAndMethodsContext = createContext();

export default dataAndMethodsContext;